import { IconProps } from "../../types/utils";

const Search = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M26.3777 24.8209L22.3961 20.8807C25.4178 17.1181 25.1334 11.5806 21.6852 8.13737C19.8723 6.3271 17.4907 5.33325 14.9311 5.33325C12.3716 5.33325 9.95449 6.32716 8.14142 8.13737C6.32853 9.94765 5.33325 12.3261 5.33325 14.9173C5.33325 17.5085 6.3286 19.8867 8.14142 21.6972C9.9543 23.472 12.3362 24.5013 14.9311 24.5013C17.0995 24.5013 19.2325 23.7557 20.903 22.407L24.8489 26.3472C25.0621 26.5601 25.3111 26.6666 25.5955 26.6666C25.8799 26.6666 26.1643 26.5601 26.3421 26.3472C26.7686 25.921 26.7686 25.2468 26.3776 24.8207L26.3777 24.8209ZM22.3961 14.9173C22.3961 16.905 21.6141 18.7864 20.1922 20.1707C18.7704 21.5551 16.9218 22.3715 14.9312 22.3715C12.9405 22.3715 11.0565 21.5905 9.67011 20.1707C8.28348 18.751 7.46594 16.905 7.46594 14.9173C7.46594 12.9295 8.248 11.0482 9.66986 9.6638C11.0919 8.27917 12.9048 7.46281 14.9312 7.46281C16.9218 7.46281 18.8058 8.24374 20.1922 9.66355C21.5786 11.0835 22.3961 12.8938 22.3961 14.9173Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Search;
